/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_accionProyecto as accionProyecto,
  rec_Bo as Bo,
  rec_EstadoError as EstadoError,
  rec_JSXRuntime as JSXRuntime,
  rec_Ki as Ki,
  rec_Mi as Mi,
  rec_NuevaEtiqueta as NuevaEtiqueta,
  rec_NuevaLista as NuevaLista,
  rec_React as React,
  rec_Wi as Wi,
  rec_api as api,
  rec_ii as ii,
  rec_nS as nS,
} from "../../runtime/index.jsx";
export function ConfiguracionProyecto({ proyecto: e }) {
  let [t, n] = (0, React.useState)([]),
    [r, i] = (0, React.useState)([]),
    [a, o] = (0, React.useState)(!0),
    [s, c] = (0, React.useState)(``),
    l = !accionProyecto(e, `planner.proyectos.editar`),
    u = (0, React.useCallback)(async () => {
      o(!0);
      try {
        let [t, r] = await Promise.all([
          api(`/etiquetas?proyecto=${e.id}`),
          api(`/listas?proyecto=${e.id}`),
        ]);
        (n(t), i(r), c(``));
      } catch (e) {
        c(e.message);
      } finally {
        o(!1);
      }
    }, [e.id]);
  return (
    (0, React.useEffect)(() => {
      u();
    }, [u]),
    a ? (
      <div
        className={`flex items-center gap-2 text-sm text-(--text)`}
        children={[
          (0, JSXRuntime.jsx)(ii, {
            className: `h-4 w-4 animate-spin`,
          }),
          ` Cargando…`,
        ]}
      />
    ) : (
      <div
        className={`grid gap-6 lg:grid-cols-2`}
        children={[
          <EstadoError mensaje={s} onReintentar={u} />,
          <section
            className={Bo}
            children={[
              <p
                className={`mb-3 flex items-center gap-1.5 font-medium text-(--text-h)`}
                children={[<Wi className={`h-4 w-4`} />, ` Etiquetas`]}
              />,
              <ul
                className={`mb-3 flex flex-col gap-1.5`}
                children={[
                  t.map((e) => (
                    <li
                      key={e.id}
                      className={`flex items-center gap-2`}
                      children={[
                        <span
                          className={`h-3 w-3 rounded-full`}
                          style={{
                            background: nS(e.color),
                          }}
                        />,
                        <span
                          className={`flex-1 text-sm text-(--text-h)`}
                          children={e.nombre}
                        />,
                        !l && (
                          <button
                            type={`button`}
                            onClick={() =>
                              api(`/etiquetas/${e.id}`, {
                                method: `DELETE`,
                              })
                                .then(u)
                                .catch((e) => c(e.message))
                            }
                            className={`text-(--text) hover:text-(--error)`}
                            children={<Ki className={`h-4 w-4`} />}
                          />
                        ),
                      ]}
                    />
                  )),
                  t.length === 0 && (
                    <li
                      className={`text-xs text-(--text)`}
                      children={`Sin etiquetas.`}
                    />
                  ),
                ]}
              />,
              !l && (
                <NuevaEtiqueta proyectoId={e.id} onCreada={u} onError={c} />
              ),
            ]}
          />,
          <section
            className={Bo}
            children={[
              <p
                className={`mb-3 flex items-center gap-1.5 font-medium text-(--text-h)`}
                children={[
                  <Mi className={`h-4 w-4 text-(--text)`} />,
                  ` Listas de tareas`,
                ]}
              />,
              <ul
                className={`mb-3 flex flex-col gap-1.5`}
                children={[
                  r.map((e) => (
                    <li
                      key={e.id}
                      className={`flex items-center gap-2`}
                      children={[
                        <span
                          className={`flex-1 text-sm text-(--text-h)`}
                          children={e.nombre}
                        />,
                        !l && (
                          <button
                            type={`button`}
                            onClick={() =>
                              api(`/listas/${e.id}`, {
                                method: `DELETE`,
                              })
                                .then(u)
                                .catch((e) => c(e.message))
                            }
                            className={`text-(--text) hover:text-(--error)`}
                            children={<Ki className={`h-4 w-4`} />}
                          />
                        ),
                      ]}
                    />
                  )),
                  r.length === 0 && (
                    <li
                      className={`text-xs text-(--text)`}
                      children={`Sin listas.`}
                    />
                  ),
                ]}
              />,
              !l && <NuevaLista proyectoId={e.id} onCreada={u} onError={c} />,
            ]}
          />,
        ]}
      />
    )
  );
}
